export default {"src":"https://static.finncdn.no/_c/travel/pp-web/_next/static/media/wa.18476bdd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};